import React from 'react'
import pluralize from 'pluralize'
import PlaylistEdit from './PlaylistEdit'
import './PlaylistHeader.scss'
import PropTypes from 'prop-types'

const PlaylistHeader = ({
  playlist,
  userIsAdmin,
  userIsAuthor,
  onPlaylistDelete,
  toggleFeatured,
  toggleFollowing,
  onPlaylistUpdate,
  signedIn,
  onDuplicated,
  deleting
}) => {
  const numFollowers = playlist.followerCount - 1 // Exclude author

  return (
    <div className='PlaylistHeader'>
      <div className='PlaylistHeader__cover'>
        <div>
          <img src={playlist.imageUrl()} />
        </div>
      </div>
      <div className='PlaylistHeader__header'>
        <div className='PlaylistHeader__nameWrapper'>
          <h3>Playlist</h3>
          <div className='PlaylistHeader__menu_wrapper'>
            <h2 className='PlaylistHeader__title'>{playlist.title}</h2>
            <div className='PlaylistHeader__edit desktop'>
              <PlaylistEdit
                playlist={playlist}
                userIsAdmin={userIsAdmin}
                userIsAuthor={userIsAuthor}
                onDelete={onPlaylistDelete}
                toggleFeatured={toggleFeatured}
                onPlaylistUpdate={onPlaylistUpdate}
                toggleFollowing={toggleFollowing}
                signedIn={signedIn}
                onDuplicated={onDuplicated}
                deleting={deleting}
              />
            </div>
          </div>
        </div>

        {playlist.htmlDescriptionAllowed ? (
          <div
            className='PlaylistHeader__description'
            dangerouslySetInnerHTML={{ __html: playlist.description }}
          ></div>
        ) : (
          <div className='PlaylistHeader__description'>
            {playlist.description}
          </div>
        )}
        <div
          className={`PlaylistHeader__extraInfo ${
            !playlist.description
              ? 'PlaylistHeader__extraInfo--noDescription'
              : ''
          }`}
        >
          <div className='PlaylistHeader__meta'>
            <div className='PlaylistHeader__metaTop'>
              <div>
                Curated by {playlist.author.firstName}{' '}
                {playlist.author.lastName}
              </div>
              <div className='divider' />
              <div className='PlaylistHeader__followers'>
                {numFollowers} {pluralize('Follower', numFollowers)}
              </div>
            </div>
            <div className='PlaylistHeader__metaBottom'>
              <div className='divider sec-divider' />
              <div>
                <span>
                  {playlist.entryCount}{' '}
                  {pluralize('Class', playlist.entryCount)}
                </span>
              </div>
              <div className='divider' />
              <div>{playlist.humanDuration}</div>
            </div>
          </div>
        </div>
      </div>
      <div className='PlaylistHeader__edit mobile'>
            <PlaylistEdit
              playlist={playlist}
              userIsAdmin={userIsAdmin}
              userIsAuthor={userIsAuthor}
              onDelete={onPlaylistDelete}
              toggleFeatured={toggleFeatured}
              onPlaylistUpdate={onPlaylistUpdate}
              toggleFollowing={toggleFollowing}
              signedIn={signedIn}
              onDuplicated={onDuplicated}
              deleting={deleting}
            />
          </div>
    </div>
  )
}

PlaylistHeader.propTypes = {
  playlist: PropTypes.object,
  signedIn: PropTypes.bool,
  userIsAdmin: PropTypes.bool,
  userIsAuthor: PropTypes.bool,
  onPlaylistDelete: PropTypes.func,
  toggleFeatured: PropTypes.func,
  onPlaylistUpdate: PropTypes.func,
  toggleFollowing: PropTypes.func,
  onDuplicated: PropTypes.func,
  deleting: PropTypes.bool
}

export default PlaylistHeader
